import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { compose } from 'redux';
import VerbButton from '../VerbButton';
import { hideModal } from '../../actions/index';
import BasicTextArea from '../formComponents/groups/BasicTextArea';
import BasicText from '../formComponents/groups/BasicText';

import FormFeedback from '../formComponents/FormFeedback';
import VerbHeading from '../VerbHeading';
import VerbText from '../VerbText';

class HelpModal extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        hideModal: PropTypes.func,
        failMsg: PropTypes.any
    };

    cancelOrClose = () => this.props.hideModal();

    render() {
        const { submitting, handleSubmit, failMsg } = this.props;

        return (
            <form className={'sendHelp'}>
                <div className={'col-12 helpInfo'}>
                    <VerbHeading
                        hNumber={3}
                        messageId={'HELP_ENCOURAGEMENT'}
                        defaultMessage={'We would love to hear from you.'}
                    />
                    <span className={'helpText'}>
                        <VerbText
                            messageId={'HELP_INSTRUCTION_TEXT'}
                            defaultMessage={
                                "The Verb support team is available Monday through Friday from 9 am to 5 pm Central time (CST) to answer any questions and take your feedback. We'll get back to you within the next 24 hours."
                            }
                        />
                    </span>
                </div>
                <Field
                    name={'subject'}
                    labelDefault={'Subject'}
                    labelTextId={'HELP_SUBJECT_LABEL'}
                    className={'col-12'}
                    component={BasicText}
                />
                <Field
                    name={'description'}
                    labelDefault={'Description'}
                    labelTextId={'HELP_DESCRIPTION_LABEL'}
                    className={'col-12'}
                    rows={3}
                    component={BasicTextArea}
                />
                <div className={'col-12 formButtons'}>
                    <VerbButton
                        className={'help-btn btn btn-default'}
                        onClick={handleSubmit}
                        disabled={submitting}
                        textId={'BUTTON_SEND'}
                        defaultMessage={'SEND'}
                    />
                    <VerbButton
                        className={'help-secondary-btn'}
                        onClick={this.cancelOrClose}
                        disabled={submitting}
                        textId={'BUTTON_CLOSE'}
                        defaultMessage={'CLOSE'}
                    />
                </div>
                <FormFeedback {...this.props} submittingMsg={'Sending...'} className={'col-12'} failMsg={failMsg} />
            </form>
        );
    }
}

export const HelpModalComponent = HelpModal;

const HelpModalValidation = {
    form: 'Help',
    validate: (values) => {
        const errors = {};
        if (!values.supportId) {
            errors.supportId = 'Field required';
        }
        if (!values.subject && !values.description) {
            const errorMsg = 'You must at least fill out Subject or Description';
            errors.subject = errorMsg;
            errors.description = errorMsg;
        }
        return errors;
    }
};

const mapStateToProps = (state) => {
    const {
        auth: { loggedInUser }
    } = state;
    return {
        initialValues: {
            from: loggedInUser.email
        }
    };
};

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(hideModal())
});
export default compose(connect(mapStateToProps, mapDispatchToProps), reduxForm(HelpModalValidation))(HelpModal);
